module.exports = __webpack_public_path__ + "img/ICON-INTEGRITY.4d42be5d.png";